import { EDocumentCategory, TDocumentCategory } from 'FeatureModules/Document/types/document.types';

const DocumentCategory: Record<
  TDocumentCategory,
  { label: string; requireDate: boolean; yearsFromIssuedDate?: number }
> = {
  [EDocumentCategory.CERTIFICATE]: {
    label: 'Certificate',
    requireDate: true,
    yearsFromIssuedDate: undefined,
  },
  [EDocumentCategory.PICTURES]: {
    label: 'Pictures',
    requireDate: false,
    yearsFromIssuedDate: undefined,
  },
  [EDocumentCategory.MANAGEMENT_LETTER]: {
    label: 'Management letter',
    requireDate: true,
    yearsFromIssuedDate: 2,
  },
  [EDocumentCategory.SHAREHOLDER_AGREEMENT]: {
    label: 'Shareholder agreement',
    requireDate: true,
    yearsFromIssuedDate: 2,
  },
  [EDocumentCategory.LABORATORY_TEST]: {
    label: 'Laboratory test',
    requireDate: true,
    yearsFromIssuedDate: undefined,
  },
  [EDocumentCategory.REPORT]: {
    label: 'Report',
    requireDate: true,
    yearsFromIssuedDate: 1,
  },
  [EDocumentCategory.STATEMENT]: {
    label: 'Statement',
    requireDate: false,
    yearsFromIssuedDate: undefined,
  },
  [EDocumentCategory.OTHER]: {
    label: 'Other document',
    requireDate: false,
    yearsFromIssuedDate: undefined,
  },
  [EDocumentCategory.GEOGRAPHICAL_FEATURES]: {
    label: 'Geographical features',
    requireDate: false,
    yearsFromIssuedDate: undefined,
  },
};

export default DocumentCategory;
